import { useCallback, useMemo } from 'react';
import { sendActionToDatadog } from '../../Datadog';
import { PERFORMANCE_MEASURE_NAMES } from '../config/constants';
import { TRemote } from '../types';

const usePerformanceLoggerForRemote = (remote: TRemote) => {
  const createActionLogger = useCallback(
    (actionName: string) => (time: number) => sendActionToDatadog(actionName, { time, remote }),
    [remote]
  );

  const onLoad = useMemo(() => createActionLogger(PERFORMANCE_MEASURE_NAMES.REMOTE_LOADED), [
    createActionLogger,
  ]);

  const onModuleEvaluation = useMemo(
    () => createActionLogger(PERFORMANCE_MEASURE_NAMES.MODULE_EVALUATION_COMPLETED),
    [createActionLogger]
  );

  return {
    onLoad,
    onModuleEvaluation,
  };
};

export default usePerformanceLoggerForRemote;
